import React, {useEffect, useState} from 'react'
import {Col, Form, Row} from "react-bootstrap";
import SubmitButton from "../Main/Dashboard/components/SubmitButton";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import columnConfig from "../Main/Dashboard/columns";
import {Api} from "../../../helpers/Api";
import "react-datepicker/dist/react-datepicker.css";
import {Validation} from "../../../helpers/Validation";
import {connect} from "react-redux";
import { renderField } from "../Main/Form/form";
import ShortUniqueId  from "short-unique-id";
import LoadingSpinner from '../Components/Spinner/LoadingSpinner';

const RegistrationForm = ({user, ...props}) => {
    const params = useParams();
    const queryParams = useSearchParams();
    const uid = new ShortUniqueId({ length: 5 });
    params.path = 'Registration';
    const [data, setData] = useState({team:[{name:"",email:"",phone:""}]});

    let config = columnConfig[params.path];
    const navigate = useNavigate();
    const [state, setState] = useState({
        loading: false,
        error: null,
        config: config,
        page: 1,
        limit: 20000,
        total: 0,
        show: false,
    });
    const [errors, setErrors] = useState({});

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const d = { ...data };
        d.team[index][name] = value;
        setData(d)
    };

    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const d = { ...data };
        d.team.splice(index, 1);
        setData(d)
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        const d = { ...data };
        d.team.push({ name: "", email: "", designation: "", description: "", });
        setData(d)
    };

    const fetchOptions = async (c) => {
        let o = await Api.call(`${c.url}`);
        let options = [{"label": "", value: ""}]
        o.map(object => {
            options.push({label: object[c.label], value: object[c.key], object});
        })
        return options;
    }

    useEffect(async () => {
        const config = {...state.config};
        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].updateOptions) {
                config.form[i].options = config.form[i].updateOptions(config.form[i].allOptions, data);
            }
        }
        setState((s) => {
            return {...s, config}
        })
    }, [data])


    useEffect(async () => {
        if (!user) {
            return;
        }
        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].fetchOptions) {
                let options = await fetchOptions(config.form[i].fetchOptions);
                if (!config.form[i].updateOptions) {
                    config.form[i].options = options;
                }
                config.form[i].allOptions = options;
            }
        }
        setState((s) => {
            return {...s, config}
        })
    }, [config, user]);

    const renderLabel = (field)=>{
        console.log(field.required);
        return <Form.Label style={{color:"white"}}>{field.name} {field.required  ? '*':''}</Form.Label>
    }
    
    const loadData = (id) => {
        if (id === 'new') {
            updateState({loading: true});
            Api.call(`/getFee?id=${params.eventId}`).then(post =>{
                let d = { ...data, ...post }
                d['template'] = params.eventId;

                // Added Unique Registration No.
                d['uuid'] = uid();
                setData(d);
            }).finally(()=>{
                updateState({loading: false});
            })
            
            return;
        }
        Api.call(`/${state.config.url}/${id}`).then(post => {
            setData(post)
            setTimeout(() => {
                console.log(data);
            }, 2000)
        }).catch(console.log).finally(() => {
            updateState({loading: false});
        });
    };

    useEffect(() => {
    
        console.log(props);
        if(params.id == "failed"){
            // url of error page or error message
        }

        else if(params.id == "Success"){
            update()
        }

        if (params.id) {
            loadData(params.id)
        }

    }, [params])

    const validate = () => {
        let errors = {};
        state.config.form.map((field) => {
            if (field.condition && data[field.condition.key] !== field.condition.value) {
                return;
            }
            if (field.required && !data[field.key]) {
                errors[field.key] = `${field.name} is required`;
            }

            if(field.validations){ 
            let validate = Validation.Ragularexpression(data[field.key],field.validations)
            if(validate && validate[0])
            { 
                let a = Validation.Ragularexpression(data[field.key],field.validations);
                 errors[field.key] = `${a[0]}`;
            }
        }
        });
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const submit = (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }
        if (data.id) {
            update();
        } else {
            create();
        }
    };

    const updateState = (obj) => {
        setState(s => {
            Object.keys(obj).forEach(key => {
                s[key] = obj[key];
            });
            return s;
        });
    }
  
    const update = () => {
        updateState({loading: true});
        Api.call(`/${state.config.url}/${data.id}`, "PUT", data).then(post => {
            setData(post)
            if(params.path === 'templates'){
                navigate(`/templates_2/${post.id}`);
            }else {
                navigate(`/${state.config.redirectUrl}`);
            }
        }).catch(console.log).finally(() => {
            updateState({loading: false});
        })
    };
    const create = () => {
        updateState({loading: true});
        Api.call(`/${state.config.url}`, "POST", data).then(post => {
            // setData([post]);
            window.open(post.url);
            navigate(`/${state.config.redirectUrl}`);
        }).catch(console.log).finally(() => {
            updateState({loading: false});
        })
    };
    const onChange = (key, value) => {
        let d = {...data};
      
        d[key] = value;
        setData(d);
    };

        return (<> { state.loading ? 
        <LoadingSpinner />: 
        <div className="dashboard mt-5">
            <div className='inner-content mt-4'>
            <h4 >Registration</h4> 
            {/* <Heading link={"test"} linkName="Edit" /> */}
                <div className='commen-form'>
                    {state.config.renderForm ?
                        state.config.renderForm() :
                        <Form autoComplete={'off'} onSubmit={submit}>
                            <Row>
                                {state.config.form.map((field) => {
                                    if (field.render) {
                                        let d = data[field.key];
                                        if (!d) {
                                            d = {};
                                        }
                                        return field.render(d, (d) => {
                                            onChange(field.key, d)
                                        })
                                    }
                                    return renderField(field,errors,data,onChange)
                                })}
                                <h4 style={{color:'black'}}>
                                    {data['registering_type'] === "Team" ? `Team` :`Personal Info`}
                                </h4>
                                {data["team"]?.map((x,index) =>{
                                    return(<Row>
                                    <Col md={3}><Form.Group controlId={x.name} key={index}>
                                    {renderLabel({name:"Name"})}
                                    <Form.Control type="text" value={x.name} name="name"
                                                  onChange={event => handleInputChange(event,index)}
                                                  placeholder="" required={ index === 0 ? true : false }/>
                                </Form.Group>               
                                </Col>
                                    
                                <Col md={3}><Form.Group controlId={x.name} key={index}>
                                    {renderLabel({name:"Role"})}
                                    <Form.Control type="text" value={x.role} name="role"
                                                  onChange={event => handleInputChange(event,index)}
                                                  placeholder="" required={ index === 0 ? true : false } />
                                </Form.Group>            
                                </Col>
                                
                                <Col md={3}><Form.Group controlId={x.name} key={index}>
                                    {renderLabel({name:"Email"})}
                                    <Form.Control type="text" value={x.email} name="email"
                                                  onChange={event => handleInputChange(event,index)}
                                                  placeholder="" required={ index === 0 ? true : false }/>
                                </Form.Group>               
                                </Col>
                                
                                <Col md={3}><Form.Group controlId={x.name} key={index}>
                                    {renderLabel({name:"Phone No."})}
                                    <Form.Control type="number" value={x.phone} maxlength="10" name="phone"
                                                  onChange={event => handleInputChange(event,index)}
                                                  placeholder="" required={ index === 0 ? true : false } />
                                </Form.Group>            
                                </Col>
                                <div className="add-more-field">
                                    {data.team.length !== 1  && <button
                                        onClick={() => handleRemoveClick(index)}>
                                        <img src='../../../../images/remove-icon.png' alt='RemoveIcon' />
                                        Remove</button>}
                                    {data.registering_type !="Individual" && data.max_team_member != null 
                                    && data.max_team_member != data.team.length 
                                    && data.team.length - 1 === index && <button onClick={handleAddClick}>
                                        <img src='../../../../images/add-more.png' alt='AddIcon' />
                                        Add</button>}
                                </div>
                                </Row>)
                            })}
                            </Row>
                            
                            <input type="hidden" value={params.eventId} name="template" />
                            <div className='mt-4 Form-buttons'>
                                <button type="button" onClick={()=>{
                                    navigate(`/${state.config.redirectUrl}`)
                                }} className='cancel'>Cancel</button>
                                 <SubmitButton label="Register" 
                                loading={state.loading}/>
                            </div>
                        </Form>
                    }
                </div>
            </div>
        </div>}</>)
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({type: 'LOGIN', data: user})
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm)
